/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

const styles = {
  container: css`
    h2 {
      margin-top: var(--cds-spacing-200);
    }
  `,
};

const PlanUpdatedDialog = () => (
  <div css={styles.container}>
    <Typography2 component="p">
      {_t(
        'Your graduation plan was automatically updated and one or more courses were removed for one or more of the following reasons:'
      )}
    </Typography2>
    <Typography variant="h2semibold">{_t('Courses not enrolled were removed')}</Typography>
    <Typography2 component="p">
      {_t(
        'The enrollment period for the academic term ended and one or more courses that you haven’t enrolled in the current academic term were removed. You can add those courses back to a future term in the plan.'
      )}
    </Typography2>
    <Typography variant="h2semibold">{_t('Courses not passed were removed')}</Typography>
    <Typography2 component="p">
      {_t(
        'The academic term ended and courses not passed were removed. You can add those courses back to the plan and enroll again.'
      )}
    </Typography2>
    <Typography variant="h2semibold">{_t('Courses not offered were removed')}</Typography>
    <Typography2 component="p">
      {_t(
        'The enrollment period for the academic term ended and one or more planned courses not offered this academic term were removed. You can add those courses back to a future term in the plan.'
      )}
    </Typography2>
    <Typography variant="h2semibold">{_t('Courses dropped were removed')}</Typography>
    <Typography2 component="p">
      {_t(
        'You have been unenrolled from the course by your institution because you dropped out of the course. You can add those courses back to a future term in the plan.'
      )}
    </Typography2>
  </div>
);

export default PlanUpdatedDialog;
